import type { ThemeProps } from '@models/types';
import type { SxProps, Theme } from '@mui/material';

export const getStartCustomPartnerSx = (theme: ThemeProps) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        p: '16px 16px 48px',
        gap: 2,
        height: '100%',

        '& p': {
            margin: 0,
        },

        '& h2': {
            margin: 0,
        },
    } satisfies SxProps<Theme>,

    divider: {
        width: '100%',
        maxWidth: 872,
        height: '1px',
        bgcolor: theme.palette.secondaryA10,
    } satisfies SxProps<Theme>,

    titleSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        width: '100%',
        maxWidth: 872,
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            textAlign: 'left',
        },
    } satisfies SxProps<Theme>,

    contentCard: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: 578,
        p: '16px 8px',
        border: `1px solid ${theme.palette.primaryA4}`,
        borderRadius: '30px',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    } satisfies SxProps<Theme>,

    faqList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%',
        mb: 2,
    } satisfies SxProps<Theme>,

    faqAccordion: {
        width: '100%',
        bgcolor: 'transparent',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '& .MuiAccordion-heading': {
            '& .MuiButtonBase-root': {
                gap: '10px',
            },
        },
        '& .MuiAccordionSummary-root': {
            minHeight: 44,
            px: 2,
            [theme.breakpoints.down('md')]: {
                px: 1,
            },
        },
        '& .MuiAccordionSummary-content': {
            m: 0,
            gap: '10px',
        },
        '& .MuiAccordionDetails-root': {
            px: 2,
            pb: 1.5,
            pl: '32px',
            mt: -1.5,
        },
        '& ul': {
            pl: 0,
            listStyle: 'disc',
        },
    } satisfies SxProps<Theme>,

    faqAccordionSummary: {
        ...theme.typography.textBold,
        color: theme.palette.textMain,
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
        '& .MuiAccordionSummary-expandIconWrapper': {
            transform: 'rotate(-90deg)',
            mr: 0,
            ml: 0,
        },
        '&.Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
            transform: 'rotate(0deg)',
        },
    } satisfies SxProps<Theme>,

    faqAccordionDetails: {
        ...theme.typography.text,
        color: theme.palette.textMain,
    } satisfies SxProps<Theme>,

    noticeBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        p: 2,
        borderRadius: 2,
        bgcolor: theme.palette.secondaryA2,
        color: theme.palette.textMain,
        mb: 2,
    } satisfies SxProps<Theme>,

    noticeText: {
        lineHeight: '20px',
        margin: 0,
    } satisfies SxProps<Theme>,

    footerSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: '100%',
        alignItems: 'center',
    } satisfies SxProps<Theme>,

    termsCheckbox: {
        ...theme.typography.smallText,
    } satisfies SxProps<Theme>,

    startButton: {
        width: 312,
        maxWidth: '100%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    } satisfies SxProps<Theme>,

    providerText: {
        textAlign: 'center',
    } satisfies SxProps<Theme>,
});
